var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
import { convertToUnits } from '~/tools/file/units.convertor';
export class ModelCategoryProperty {
    articlesCnt;
    docsCnt;
    filesCnt;
    photosCnt;
    status;
    videoCnt;
    weight;
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelCategoryProperty.prototype, "articlesCnt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelCategoryProperty.prototype, "docsCnt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelCategoryProperty.prototype, "filesCnt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelCategoryProperty.prototype, "photosCnt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ModelCategoryProperty.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelCategoryProperty.prototype, "videoCnt", void 0);
__decorate([
    Expose(),
    Transform(({ value }) => convertToUnits(value)),
    __metadata("design:type", Number)
], ModelCategoryProperty.prototype, "weight", void 0);
